import { createContext } from 'react';

type ISpinLoadingContext = {
  loading: boolean;
  setLoading: (value: boolean) => void;
};

export const SpinLoadingContext = createContext<ISpinLoadingContext>({
  loading: false,
  setLoading: () => {
    console.warn('setLoading is called');
  },
});
